import gql from 'graphql-tag'

export const CONTACT_PHONE_NUMBER_DELETE_MUTATION = gql`
    mutation contactPhoneNumberDelete(
        $id: ID!
    ) {
        contactPhoneNumberDelete(
            id: $id
        ) {
            status
        }
    }
`
